import { Dropdown } from "react-bootstrap";

const DropDowContact = () => {
  return (
    <>
      <Dropdown>
        <Dropdown.Toggle variant="success" id="dropdown-basic" className="DropDownContact">
          CONTACTANOS
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item href="/contacto">Contacto</Dropdown.Item>
          <Dropdown.Item href="/donde-comprar">Donde Comprar</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};
export default DropDowContact;